import { styled, Tabs as MuiTabs } from '@mui/material';

export const Tabs = styled(MuiTabs)(({ theme }) => ({
  '.MuiTabs-indicator': {
    top: 0,
  },
  '.Mui-selected': {
    pointerEvents: 'none',
    cursor: 'not-allowed',
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.action.selected,
  },
  '.MuiTabs-flexContainer': {
    border: `1px solid ${theme.palette.divider}`,
    borderBottomWidth: '0',
  },
  [theme.breakpoints.up('md')]: {
    '& .MuiTab-root': {
      borderRight: `1px solid ${theme.palette.divider}`,
      borderTop: `2px solid transparent`,
      padding: theme.spacing(1.5, 3.125),
    },
    '& .MuiTab-root:hover': {
      borderTop: `1px solid ${theme.palette.primary.main}`,
      boxShadow: `0 -1px ${theme.palette.primary.main}`,
      backgroundColor: `${theme.palette.action.hover}`
    },
  },
  [theme.breakpoints.down('md')]: {
    '& .MuiTab-root': {
      borderBottom: `1px solid ${theme.palette.divider}`,
      padding: theme.spacing(1.5, 3.125),
    },
    '& .MuiTab-root:nth-last-of-type(1)': {
      borderBottom: 'none',
    },
    '& .MuiTab-root:hover': {
      borderRight: `1px solid ${theme.palette.primary.main}`,
      boxShadow: `2px 0px 0 0 ${theme.palette.primary.main}`,
      backgroundColor: `${theme.palette.action.hover}`
    },
  },
}));
